declare function standardLoad(el: HTMLCollectionOf<Element>): undefined;
export function initSocialEmbed() {
    const embedEls = document.getElementsByClassName('embedsocial-hashtag');
    if (typeof standardLoad !== 'undefined' && embedEls.length > 0) {
        standardLoad(embedEls);
    } else {
        setTimeout(initSocialEmbed, 1500);
    }
}
